import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/fonts/fonts.css'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { LocaleProvider } from './components/common/LocaleContext';
import { StoryblokProvider } from './components/common/StoryblokContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StoryblokProvider>
      <Router>
        <LocaleProvider>
          <App />
        </LocaleProvider>
      </Router>
    </StoryblokProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
